<template>
  <div class="no-data">
    <img src="@/static/images/other/wushuju.png" alt="暂无数据" />
    <p class="green">暂无数据</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.no-data {
  padding-top: 200px;
  text-align: center;
  img {
    width: 210px;
    height: 179px;
  }
  p {
    padding-top: 53px;
  }
}
</style>
